import { useContext } from 'react';

import { AssetsInfoContext } from '@contexts/AssertInfoContext';

export const useAssetsInfo = () => useContext(AssetsInfoContext);
